export default function (hexColor, lightness) {
    let hex = String(hexColor).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex.replace(/(.)/g, '$1$1');
    }
    const lum = lightness || 0;
    let rgb = '#';
    let c;
    for (let i = 0; i < 3; ++i) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ('00' + c).substr(c.length);
    }
    return rgb;
}
